import axios, { type AxiosError } from 'axios';
import axiosRetry from 'axios-retry';
import authService from 'src/services/authService';
import { refreshPage } from 'src/store/errorBoundarySlice';
import { setIsAUSTINDown } from 'src/store/newJmrPageSlice/newJmrPageSlice';

import store from '../store/store';

import {
  handleAxiosError,
  isErrorFromGetAccommodationIdByCaseIdAndLoginApi,
  isErrorFromIncidentAPI,
  isUnauthorizedError,
} from './clientHelpers';

// old api client
const apiClient = axios.create({
  baseURL: 'https://prod.na.rtw-api.whs.amazon.dev',
});

axiosRetry(apiClient, {
  retries: 1, // number of retries
  retryDelay: (retryCount: number) => {
    console.info(`retry attempt: ${retryCount}`);
    // use store.dispatch(getUser()) will make retry instantly, which cause more chance to having race condition
    authService.login(apiClient);
    return retryCount * 2000; // time interval between retries
  },
  retryCondition: (error: AxiosError) => {
    // if retry condition is not specified, by default idempotent requests are retried
    console.error(JSON.stringify(error));
    return isUnauthorizedError(error);
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // This is to prevent toasts on cancelled requests
    if (axios.isCancel(error)) {
      console.info('Request cancelled:', error.message);
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      store.dispatch(refreshPage());
    } else if (error.response?.status !== 429) {
      // If the response is from the incident API swallow the error let the,
      // React component handle the error messaging
      // TODO : move this out of global interceptors
      if (isErrorFromIncidentAPI(error)) {
        store.dispatch(setIsAUSTINDown(true));
        return;
      } else {
        store.dispatch(setIsAUSTINDown(false));
      }

      // TODO : move this out of global interceptors
      // if the response is from query AUSTIN case id,
      // swallow the error let React component handle the redirect
      if (isErrorFromGetAccommodationIdByCaseIdAndLoginApi(error)) {
        return error.response?.data;
      }
      handleAxiosError(error);
    }
  },
);

export default apiClient;
